import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const createForumTopic = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.FORUM_AREA.CREATE_FORUM_TOPIC,
    data
  );
};

export default createForumTopic;
